import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {sortBy} from '../../../constants'
import {arrayToSet, filterMapByKeys} from '../../../../../atUtils'

const initialState = {
    isShow: false,
    loading: false,
    isShownRemoveAllConfirm: false,
    selectedYear: '',
    sorting: {
        by: sortBy.DATE,
        asc: false,
    },
    isListTransformed: false,
    importedHolidayDates: {},
    hasHolidaysInPast: false,
    loadingHolidays: false,
}

export default handleActions({
    [ActionTypes.HOLIDAYS_LIST_PANEL_SHOWN_SET]: (state) => ({
        ...state,
        isShow: true
    }),
    [ActionTypes.CLOSE_PANEL]: (state) => ({
        ...state,
        isShow: false,
        isShownRemoveAllConfirm: false
    }),
    [ActionTypes.REMOVE_ALL_CONFIRMATION_SHOW]: (state) => ({
        ...state,
        isShownRemoveAllConfirm: true
    }),
    [ActionTypes.REMOVE_ALL_CONFIRMATION_CLOSE]: (state) => ({
        ...state,
        isShownRemoveAllConfirm: false
    }),
    [ActionTypes.SELECTED_YEAR_SET]: (state, {payload: selectedYear}) => ({
        ...state,
        selectedYear: selectedYear
    }),
    [ActionTypes.LOAD_DATA]: (state) => ({
        ...state,
        loading: true
    }),
    [ActionTypes.LOAD_DATA_SUCCESS]: (state) => ({
        ...state,
        loading: false,
    }),
    [ActionTypes.LOAD_DATA_FAILURE]: (state) => ({
        ...state,
        loading: false
    }),
    [ActionTypes.CHANGE_SORT]: (state, {payload: sorting}) => ({
        ...state,
        sorting: sorting
    }),
    [ActionTypes.LIST_TRANSFORMED_SET]: (state, {payload: isListTransformed}) => ({
        ...state,
        isListTransformed: isListTransformed
    }),
    [ActionTypes.IMPORTED_HOLIDAYS_ADD]: (state, {payload: dates}) => ({
        ...state,
        importedHolidayDates: {...state.importedHolidayDates, ...arrayToSet(dates)}
    }),
    [ActionTypes.IMPORTED_HOLIDAYS_REMOVE]: (state, {payload: dates}) => ({
        ...state,
        importedHolidayDates: filterMapByKeys(state.importedHolidayDates, dates)
    }),
    [ActionTypes.LOAD_HOLIDAYS]: (state) => ({
        ...state,
        loadingHolidays: true,
    }),
    [ActionTypes.LOAD_HOLIDAYS_SUCCESS]: (state, {payload: {holidays, hasHolidaysInPast}}) => ({
        ...state,
        holidays,
        hasHolidaysInPast,
        loadingHolidays: true,
    }),
    [ActionTypes.LOAD_HOLIDAYS_FAILURE]: (state) => ({
        ...state,
        loadingHolidays: false,
    }),
}, initialState)


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/reducer.js